import { Navigate, Outlet } from "react-router-dom";
import { getAccessToken } from "context/OAuth/authService";

const AuthRoutes = () => {
  return getAccessToken() ? <Navigate to="/" replace /> : <Outlet />;
};
export default AuthRoutes;